import { SENTRY_DOMAIN } from 'shared/config'

export const getSentryReplaysLinkByUserId = (id: number | string) => {
  if (!SENTRY_DOMAIN) return ''
  return `${SENTRY_DOMAIN}/organizations/sentry/replays/?query=user.id%3A${id}&statsPeriod=24h`
}
